export const it = {
  limitation: {
    details: "Dettagli",
    duration: "Durata",
    durationError: "Selezione una durata valida",
    durations: {
      permanent: "Permanente",
      temporary: "Temporanea",
    },
    name: "Nome",
    nameError: "Inserire un nome valido",
    limitation: "Limitazione",
    limitations: "Limitazioni",
  },
  navigation: {
    limitation: "Limitazioni",
  },
};
